
























import { Component, Mixins } from "vue-property-decorator";
import WithItemsMixin from "../private/WithItemsMixin";

@Component
export default class AbcLinkList extends Mixins(WithItemsMixin) {
    private onClick(index: number) {
        if (!this.items) {
            return;
        }
        const item = this.items[index];
        if (this.isItemDisabled(item)) {
            return;
        }
        if (!Array.isArray(this.selectedItem) && this.isEqual(this.selectedItem, item)) index = -1;
        this.$emit("select", index);
    }

    private isSelected(item: any): boolean {
        return Array.isArray(this.selectedItem)
            ? this.selectedItem.some((si) => this.isEqual(si, item))
            : this.isEqual(item, this.selectedItem);
    }

    private linkClass(item: any) {
        return {
            "font-bold": this.isSelected(item),
            "text-secondary-500": this.isItemDisabled(item),
        };
    }
}
